(function () {
  var TARGET_METHOD = "LOCAL_DELIVERY";
  var DEFAULT_ADDRESS = "Address if no Hotel/Google Map entered";

  function createPrefill(address1, city, zip) {
    return {
      address1: address1,
      city: city,
      province: "Phuket",
      zip: zip,
      country: "TH",
    };
  }

  var LOCATION_PREFILLS = {
    "898006003168": createPrefill("TBD", "Phuket", "83130"),
    "828443875513": createPrefill(DEFAULT_ADDRESS, "Bang Tao", "83110"),
    "756698583431": createPrefill(DEFAULT_ADDRESS, "Cape Panwa", "83000"),
    "500420564471": createPrefill(DEFAULT_ADDRESS, "Chalong", "83130"),
    "365706167830": createPrefill(DEFAULT_ADDRESS, "Kamala", "83150"),
    "266257560024": createPrefill(DEFAULT_ADDRESS, "Karon/Kata", "83100"),
    "333075479684": createPrefill(DEFAULT_ADDRESS, "Koh Kaew", "83000"),
    "120824798122": createPrefill(DEFAULT_ADDRESS, "Mai Khao", "83110"),
    "925287988254": createPrefill(DEFAULT_ADDRESS, "Nai Thon", "83110"),
    "470742079895": createPrefill(DEFAULT_ADDRESS, "Patong", "83150"),
    "781001067252": createPrefill(DEFAULT_ADDRESS, "Phuket City", "83000"),
    "333398219731": createPrefill(DEFAULT_ADDRESS, "Phuket International Airport", "83111"),
    "643946442922": createPrefill(DEFAULT_ADDRESS, "Rawai", "83130"),
    "678821187522": createPrefill(DEFAULT_ADDRESS, "Surin", "83110"),
    "763248564602": createPrefill(DEFAULT_ADDRESS, "Thalang", "83110"),
  };

  var activePrefill;

  function getLocationId(location) {
    if (location == null) return "";
    if (typeof location === "object") return String(location.id || "");
    return String(location);
  }

  function parseInternalSelection(value) {
    if (!value || typeof value !== "string") return undefined;

    var parts = value.split("|");
    return {
      method: parts[0] || undefined,
      locationId: parts[3] || undefined,
    };
  }

  function getPrefillForSelection(selection) {
    if (!selection || selection.method !== TARGET_METHOD) return undefined;

    var locationId = getLocationId(
      selection.location || selection.pickupLocation || selection.locationId
    );

    return LOCATION_PREFILLS[locationId];
  }

  function getSelectionFromDom() {
    var internalSelectionInput = document.querySelector('input[name*="__buunto_selection"]');
    var parsedSelection = parseInternalSelection(internalSelectionInput && internalSelectionInput.value);

    if (parsedSelection && parsedSelection.method) {
      return parsedSelection;
    }

    var locationSelect = document.querySelector(".buunto-pickup-location-picker-dropdown");
    if (locationSelect && locationSelect.value) {
      return {
        method: TARGET_METHOD,
        locationId: locationSelect.value,
      };
    }

    return undefined;
  }

  function buildQueryString(prefill) {
    var params = new URLSearchParams();

    params.set("checkout[shipping_address][address1]", prefill.address1);
    params.set("checkout[shipping_address][city]", prefill.city);
    params.set("checkout[shipping_address][province]", prefill.province);
    params.set("checkout[shipping_address][zip]", prefill.zip);
    params.set("checkout[shipping_address][country]", prefill.country);
    params.set("checkout[pick_up_in_store][selected]", "false");
    params.set("method", "delivery");
    params.set("step", "contact_information");

    return params.toString();
  }

  function buildCartActionUrl(prefill) {
    return "/cart?" + buildQueryString(prefill);
  }

  function getCartForms() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        'form#cart, form#CartDrawer-Form, form#cart-notification-form, form[action*="/cart"]:not([action*="/cart/add"])'
      )
    );
  }

  function applyFormActions() {
    var forms = getCartForms();

    forms.forEach(function (form) {
      if (!activePrefill) {
        if (
          form.dataset.buuntoLocationPrefill === "true" &&
          form.action === form.dataset.buuntoPrefillAction
        ) {
          form.action = form.dataset.buuntoOriginalAction || "/cart";
        }

        delete form.dataset.buuntoLocationPrefill;
        delete form.dataset.buuntoOriginalAction;
        delete form.dataset.buuntoPrefillAction;
        return;
      }

      if (form.dataset.buuntoLocationPrefill !== "true") {
        form.dataset.buuntoOriginalAction = form.getAttribute("action") || "/cart";
      }

      form.dataset.buuntoLocationPrefill = "true";
      form.action = buildCartActionUrl(activePrefill);
      form.dataset.buuntoPrefillAction = form.action;
      form.method = "post";
    });
  }

  function syncFromSelection(selection) {
    activePrefill = getPrefillForSelection(selection);
    applyFormActions();
  }

  function syncFromDom() {
    syncFromSelection(getSelectionFromDom());
  }

  document.addEventListener("BuuntoDatePicker:selectionChange", function (event) {
    syncFromSelection(event.detail);
  });

  document.addEventListener("click", syncFromDom, true);

  document.addEventListener("DOMContentLoaded", syncFromDom);

  new MutationObserver(function () {
    if (activePrefill) applyFormActions();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
